import { SANITIZE_MODE, sanitizeStepContent } from '../../shared/utils/sanitizeStepContent';

/**
 * PostgreSQL JSON/text columns reject U+0000. Strip from workflow payloads before persist/API.
 * Step HTML fields are allowlist-sanitized on save (parity with backend SanitizeSteps).
 */
function stripNullBytes(str) {
  return str.split('\0').join('');
}

function stripNullCharacters(value) {
  if (typeof value === 'string') {
    return stripNullBytes(value);
  }
  if (Array.isArray(value)) {
    return value.map(stripNullCharacters);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, sanitizeStepField(key, entry)])
    );
  }
  return value;
}

function sanitizeStepField(key, value) {
  if (key === 'text' && typeof value === 'string') {
    return sanitizeStepContent({ text: stripNullBytes(value) }, SANITIZE_MODE.PERSIST).text;
  }
  if (key === 'graphic' && typeof value === 'string') {
    return sanitizeStepContent({ graphic: stripNullBytes(value) }, SANITIZE_MODE.PERSIST).graphic;
  }
  return stripNullCharacters(value);
}

function sanitizeWorkflowSteps(steps) {
  if (!Array.isArray(steps)) return steps;
  return steps.map((step) => {
    if (!step || typeof step !== 'object') return step;
    return Object.fromEntries(
      Object.entries(step).map(([key, value]) => [key, sanitizeStepField(key, value)])
    );
  });
}

export function sanitizeWorkflow(workflow) {
  if (!workflow || typeof workflow !== 'object') return workflow;

  return {
    ...workflow,
    name: typeof workflow.name === 'string' ? stripNullBytes(workflow.name) : workflow.name,
    description:
      typeof workflow.description === 'string'
        ? stripNullBytes(workflow.description)
        : workflow.description,
    instruction:
      typeof workflow.instruction === 'string'
        ? stripNullBytes(workflow.instruction)
        : workflow.instruction,
    required_tools:
      typeof workflow.required_tools === 'string'
        ? stripNullBytes(workflow.required_tools)
        : workflow.required_tools,
    required_parts:
      typeof workflow.required_parts === 'string'
        ? stripNullBytes(workflow.required_parts)
        : workflow.required_parts,
    workflow_steps: sanitizeWorkflowSteps(workflow.workflow_steps),
  };
}
